export const UPDATE_NEXT_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_RESOLVED_LANGUAGE = 'UPDATE_RESOLVED_LANGUAGE';

type LocaleProviderStateProps = {
  isInitialized: boolean;
  isLocaleLoading: boolean;
  nextLocale: string;
  resolvedLocale: string;
};

type LocaleProviderActionProps =
  | { type: typeof UPDATE_NEXT_LANGUAGE; value: string }
  | { type: typeof UPDATE_RESOLVED_LANGUAGE; value: string };

export const initialState: LocaleProviderStateProps = {
  isInitialized: false,
  isLocaleLoading: true,
  nextLocale: 'en',
  resolvedLocale: '',
};

export const reducer = (
  state: LocaleProviderStateProps,
  action: LocaleProviderActionProps
): LocaleProviderStateProps => {
  switch (action.type) {
    case UPDATE_NEXT_LANGUAGE:
      return {
        ...state,
        isInitialized: true,
        isLocaleLoading: true,
        nextLocale: action.value,
      };
    case UPDATE_RESOLVED_LANGUAGE:
      return {
        ...state,
        isLocaleLoading: false,
        resolvedLocale: action.value,
      };
    default:
      return state;
  }
};
